module.exports = __webpack_public_path__ + "img/team-lars@2x.54d4ba5f.jpg";